export type SecurityLogLevel = 'debug' | 'info' | 'warn' | 'error' | 'log';

function formatMessage(message: string): string {
    return `[${new Date().toISOString()}] ${message}`;
}

function write(level: SecurityLogLevel, message: string, ...args: unknown[]): void {
    console[level](formatMessage(message), ...args);
}

export const securityLog = {
    debug(message: string, ...args: unknown[]): void {
        write('debug', message, ...args);
    },
    info(message: string, ...args: unknown[]): void {
        write('info', message, ...args);
    },
    warn(message: string, ...args: unknown[]): void {
        write('warn', message, ...args);
    },
    error(message: string, ...args: unknown[]): void {
        write('error', message, ...args);
    },
    log(message: string, ...args: unknown[]): void {
        write('log', message, ...args);
    }
};
